/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
export type EditSeminarScheduleSeminarScheduleFragment = { id: string, startedAt: TimeString, endedAt: TimeString, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString, applicantCount: number };

export const EditSeminarScheduleSeminarScheduleFragmentDoc = gql`
    fragment EditSeminarScheduleSeminarSchedule on Schedule {
  id
  startedAt
  endedAt
  location
  isOnline
  capacity
  applicationDue
  applicantCount
}
    `;